export enum CertificateStatus {
    Positive = "positive",
    Negative = "negative",
    Neutral = "neutral",
    Info = "info",
    Other = "other",
}
